import store from '../store'
export default function pabulicPage({ next, router, to }) {

/* console.log('Current route name auth:', to.name);
console.log('Current route name router:', router); */
store.commit('AppModule/setLayout', 'guest');
  return next();
}